/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetShippingSourceInformationResponse
 */
export interface ResponseGetShippingSourceInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    countryId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    postalCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    prefectureId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetShippingSourceInformationResponse
     */
    userId?: number;
}

/**
 * Check if a given object implements the ResponseGetShippingSourceInformationResponse interface.
 */
export function instanceOfResponseGetShippingSourceInformationResponse(value: object): value is ResponseGetShippingSourceInformationResponse {
    return true;
}

export function ResponseGetShippingSourceInformationResponseFromJSON(json: any): ResponseGetShippingSourceInformationResponse {
    return ResponseGetShippingSourceInformationResponseFromJSONTyped(json, false);
}

export function ResponseGetShippingSourceInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetShippingSourceInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine1': json['address_line1'] == null ? undefined : json['address_line1'],
        'city': json['city'] == null ? undefined : json['city'],
        'countryId': json['country_id'] == null ? undefined : json['country_id'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'prefectureId': json['prefecture_id'] == null ? undefined : json['prefecture_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function ResponseGetShippingSourceInformationResponseToJSON(json: any): ResponseGetShippingSourceInformationResponse {
    return ResponseGetShippingSourceInformationResponseToJSONTyped(json, false);
}

export function ResponseGetShippingSourceInformationResponseToJSONTyped(value?: ResponseGetShippingSourceInformationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line1': value['addressLine1'],
        'city': value['city'],
        'country_id': value['countryId'],
        'id': value['id'],
        'name': value['name'],
        'phone_number': value['phoneNumber'],
        'postal_code': value['postalCode'],
        'prefecture_id': value['prefectureId'],
        'user_id': value['userId'],
    };
}

